(function () {
    'use strict';

    angular
        .module('partners')
        .controller('PartnerDashboardController', PartnerDashboardController);

    PartnerDashboardController.$inject = ['ManagePartnersService', 'ExpoService', '$uibModal'];

    function PartnerDashboardController(ManagePartnersService, ExpoService, $uibModal) {
        var vm = this;

        //vm.partners = partnersList.data.data;
        vm.expos = [];
        vm.expoSelected = [];
        vm.exposAll = [{
            name: '--- All ---'
        }];

        vm.loadExpos                 = loadExpos;
        vm.getByFilter               = getByFilter;
        vm.openInformation           = openInformation;
        vm.openRegisteredInformation = openRegisteredInformation;
        vm.openAttendedInformation   = openAttendedInformation;
        vm.statistics                = statistics;


        vm.setPage = setPage;
        vm.pageChanged = pageChanged;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        // vm.totalItems   = partnersList.data.total;
        // vm.currentPage  = partnersList.data.current_page;
        // vm.itemsPerPage = partnersList.data.per_page;
        vm.page         = 1;


        function activate() {
            vm.getByFilter();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function loadExpos() {
            ExpoService.getExposForSelect().then(function(response) {
                vm.expos = vm.exposAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.query = {};
            vm.query['event_id'] = vm.expoSelected.id;
            vm.query['page'] = vm.page;
            vm.query['paginate'] = 20;
            ManagePartnersService.getByFilterPartner(vm.query).then(function(response) {
                vm.partners = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }

        function openInformation(partner) {
            $uibModal.open({
                templateUrl: 'templates/partners/show/template.modal.html',
                controller: 'PartnerModalController',
                controllerAs:'vm',
                resolve: {
                    partner: function() {
                        return partner;
                    }
                }
            });
        }

        function openRegisteredInformation(partner) {
            $uibModal.open({
                templateUrl: 'templates/partner/dashboard/registered/registered.modal.html',
                controller: 'PartnerDashboardRegisteredModalController',
                controllerAs:'vm',
                resolve: {
                    partner: function() {
                        return partner;
                    }
                }
            });
        }

        function openAttendedInformation(partner) {
            $uibModal.open({
                templateUrl: 'templates/partner/dashboard/attended/attended.modal.html',
                controller: 'PartnerDashboardAttendedModalController',
                controllerAs:'vm',
                resolve: {
                    partner: function() {
                        return partner;
                    }
                }
            });
        }

        function statistics(partner) {
            vm.flag = false;
            vm.query = {};

            vm.query['partner_id']  = partner.id;
            vm.query['expo_id']     = partner.event_id;

            ManagePartnersService.statistics(vm.query).then(function(response){
                $uibModal.open({
                    templateUrl: 'templates/partners/statistics/reportFilter.html',
                    controller: 'PartnersStatisticsController',
                    controllerAs:'partnersStatistics',
                    size: 'lg',
                    resolve: {
                        statistics: function() {
                            return response.data;
                        },
                        partner: function () {
                            return partner;
                        }
                    }
                });
            }).catch(function(err){

            });

            vm.flagForViewGraph = true;
        }

        activate();

    }

})();
